export const WORKORDER_HEIGHT = 118
export const WORKORDER_WIDTH = 225
